
import React, { useState } from 'react';






import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Row,
  } from "reactstrap";


import question from '../../assets/img/question.svg'





const IntensityHelpModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  
  const [modal, setModal] = useState(false);
  

  const toggle = () => setModal(!modal);
  console.log(props.deviat)
  return (
    <div>
       <img alt="" onClick={toggle} src={question}  className="icons" style={{height:"20px",width:'20px',cursor:'pointer'}}/>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Intensity and running program</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row style={{padding:'10px'}}>     
               <p>Intensity controls how hard a program will be, or in better words how low the negative perceived stress will go in the training load graph(higher stress score program) </p>
               <p className='text-warning'>Intensity factor is a calibration factor to adjust the program to your initial training habits. It is safe to choose a value between 7-15 and ALWAYS choose the same value on the rest of the training season.</p>
               <ul className='text-success'>
                  <li className='text-warning'>Intensity factor lower than 7 : If you are recovering from an injury</li>
                  <li>Intensity factor  7 - 15: For athletes of all levels, from completely begieners to competitive runners</li>
                  <li>Intensity factor  10: Sweet spot for all levels. For athletes of all levels, from completely begieners to competitive runners</li>
                  <li className='text-danger'>Intensity factor greater than 15: Only if you know what you are doing, or you think that the app underestimated your initial fitness ( this can happen if you haven't imported all of your last year activities or you usually train on a different sport not currently supported on this app</li>
              </ul>
               <p>
                   If you belong in the fourth category try different intensity values and watch the projected training load graph until you find the sweet spot that satisfies you.
                   If you are not accustomed with the training load graph yet choose an intensity that will drive the perveived stress score for the next month close to a value in the range of <span className='text-warning'>-7 to -15</span>

               </p>
                <p>
                    In the ideal scenario intensity matches the perceived stress. But different choises in weekly run numbers and different starting fitness,fatigue values will produce unpredictable results
                    
                </p>
                <p className='text-danger'>
                    Important! As the training months pass, you don't have to increase the intensity, it is important to choose an intensity and stick with it. As the app gets feedback about your training status,fitness and fatigue levels, it will get increasingly harder in the same intensity value. This isn't something you have to readjust every month.
                </p>
                
            </Row>
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function feedbackMessage(deviation){
    var message = "Need more Data. Train more and come back later for feedback"
    if (deviation<=0.1){
        message = 'Need more Data. Train more and come back later for feedback'
        return [message,'text-warning']
      }
    if (deviation<=1){
      message = 'Excellent work your training habits are very consistent.'
      return [message,'text-success']
    }
    if (deviation<=3){
        message = 'Your training habits consistent.'
        return [message,'text-info']
    }
    if (deviation<=5){
        message = 'Your training habits are not consistent. Consider following a more structured program. Injury risk is moderate'
        return [message,'text-warning']
    }
    if (deviation<=10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is high'
        return [message,'text-danger']
    }
    if (deviation>10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is critical high'
        return [message,'text-danger']
    }
    return [message,'text-warning']
}
export default IntensityHelpModal;